class CollectionSubcategoriesSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.sliderContainer = this.querySelector('.swiper');
    this.initSlider();
  }

  async initSlider() {
    if (!this.sliderContainer) return;

    const { Swiper, Navigation } = await import(flu.chunks.swiper);
    
    // Hardcode mobile to 2 slides with peek effect
    const mobilePerView = 2 * 1.05;

    const swiperOptions = {
      modules: [Navigation],
      slidesPerView: mobilePerView,
      spaceBetween: 16,
      navigation: {
        nextEl: this.querySelector('[data-next]'),
        prevEl: this.querySelector('[data-prev]'),
      },
      breakpoints: {
        720: {
          spaceBetween: 16,
          slidesPerView: 'auto' // Auto-adjust based on slide width (130px)
        }
      }
    };

    this.swiper = new Swiper(this.sliderContainer, swiperOptions);
  }

  connectedCallback() {
    // Already initialized in constructor
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('collection-subcategories-slider', CollectionSubcategoriesSlider);
